import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

import PortalContractsTable from "../components/PortalContractsTable.jsx";

/**
 * The full Verträge list. See PortalContractsTable.jsx for the table itself,
 * including its own search field.
 */
export default function ContractListPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Übersicht", path: "/" },
      { name: "Verträge", path: "/vertraege" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Verträge
      </Typography>
      <PortalContractsTable />
    </Box>
  );
}
